import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import jwtDecode from 'jwt-decode';
import { loginAction, logoutAction, refreshTokenAction } from '../redux/auth';
import {refreshUserToken} from  "../api/auth"

/**
 * Fournisseur d'authentification qui gère:
 * - La persistance de l'état d'authentification
 * - Le rafraîchissement automatique des tokens
 */
const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { 
    isAuthenticated, 
    token, 
    refreshToken,
    isTokenValidated
  } = useSelector(state => state.auth);

  // Initialisation de l'état d'authentification
  useEffect(() => {
    const initializeAuth = async () => {
      try {
        // Vérifier la validité du token
        const decodedToken = jwtDecode(token);
      if (decodedToken.exp * 1000 > Date.now()) {
            dispatch(loginAction(
                    decodedToken.user, 
                    token, 
                    refreshToken
                  ));
            } else {
                  dispatch(logoutAction());
                }
      } catch (error) {
        console.error('Error restoring authentication state:', error);
        dispatch(logoutAction());
      }
    };

    if (token && refreshToken && !isTokenValidated) {
      initializeAuth();
    }
  }, [dispatch, token, refreshToken, isTokenValidated]);

  // Configuration du rafraîchissement automatique du token
  useEffect(() => {
    if (!isAuthenticated || !token || !refreshToken) return;

    let refreshTimer;

    const setupTokenRefresh = async () => {
      try {
        const decodedToken = jwtDecode(token);
        const expirationTime = decodedToken.exp * 1000;
        const currentTime = Date.now();
        const remainingTime = expirationTime - currentTime;
        
        // Planifier le rafraîchissement 1 minute avant l'expiration
        const refreshTime = Math.max(0, remainingTime - 60000);
        
        refreshTimer = setTimeout(async () => {
          try {

            const response = await refreshUserToken(refreshToken)
            const newToken = response.token;
            const newRefreshToken = response.refreshToken;
            
            // Mettre à jour le store avec les nouveaux tokens
            dispatch(refreshTokenAction(newToken, newRefreshToken));
          } catch (error) {
            console.error('Token refresh failed:', error);
            dispatch(logoutAction());
          }
        }, refreshTime);
      } catch (error) {
        console.error('Error setting up token refresh:', error);
      }
    };

    setupTokenRefresh();

    return () => {
      if (refreshTimer) clearTimeout(refreshTimer);
    };
  }, [isAuthenticated, token, refreshToken, dispatch]);

  return <>{children}</>;
};

export default AuthProvider;